// extracted by mini-css-extract-plugin
module.exports = {"styledContainer":"aGTEyVMD"};